import { ReactElement, useState } from 'react';
import styles from './utmb-plus-placeholder.module.scss';
import { Placeholder } from '../placeholder/placeholder';
import { Icon } from '@utmb/design-system/icons/Icon';
import { IconsEnum } from '@utmb/types/icons';
import { Font } from '@utmb/design-system/text/font';
import { UtmbPlusPopin } from '../utmb-plus-popin/UtmbPlusPopin';
import { toast } from 'react-toastify';
import { useTranslation } from 'next-i18next';

export function UtmbPlusPlaceholder(): ReactElement {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const { t } = useTranslation('myutmb');

    function handleClose(success?: boolean) {
        if (success) toast.success(t('myUtmb.loyalty.registerPlaceholder.success'));
        setIsOpen(false);
    }

    return (
        <div className={styles.utmbPlusPlaceholder}>
            <Placeholder
                image="/worldseries/MYUTMB+/placeholder-1.png"
                variant="small"
                cta={{
                    label: t('myUtmb.loyalty.registerPlaceholder.button'),
                    action: () => setIsOpen(true),
                }}
            >
                <Font.FuturaMedium desktop="22" mobile="22" as="div" className={styles.wrapText}>
                    <span dangerouslySetInnerHTML={{ __html: t('myUtmb.loyalty.registerPlaceholder.label') }} />
                </Font.FuturaMedium>
            </Placeholder>
            <div className={styles.paternTop}>
                <Icon variant={IconsEnum.NINEPLUS} width={250} height={115} />
            </div>
            <div className={styles.paternBottom}>
                <Icon variant={IconsEnum.NINEPLUS} width={250} height={115} />
            </div>
            {isOpen ? <UtmbPlusPopin closeCallback={handleClose} /> : null}
        </div>
    );
}
